<template>
  <transition name="move">
    <div class="face-select-box" ref="face" v-show="copyVisible">
      <ul class="face-lists clearfix">
        <li
          class="face-list"
          v-for="(item, index) in sendControl.faces"
          :key="index"
          @click.stop="handleClick(item)"
        >
          <img :src="item.url" class="face" />
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import BScroll from 'better-scroll'

export default {
  props: {
    visible: Boolean
  },
  computed: {
    ...mapState(['sendControl'])
  },
  data () {
    return {
      copyVisible: this.visible
    }
  },
  methods: {
    handleClick (item) {
      this.copyVisible = false
      this.sendControl.addFace(item.key)
    }
  },
  watch: {
    visible () {
      this.copyVisible = this.visible
    },
    copyVisible () {
      this.$emit("update:visible", this.copyVisible)
      if (this.copyVisible && !this.bscroll) {
        this.$nextTick(() => {
          this.bscroll = new BScroll(this.$refs.face, {
            click: true,
            scrollY: true
          })
        })
      }
    }
  }
}
</script>

<style lang="stylus">
.face-select-box {
  position: fixed;
  left: 0;
  bottom: 50px;
  z-index: 98;
  background: #fff;
  width: 100%;
  overflow-y: auto;
  max-height: 240px;
  box-shadow: 3px -4px 15px #c1bfbf;
  border-top: 1px solid #e4e4e4;
  background: #eff4f7;

  &.move-enter-active, &.move-leave-active {
    transition: all 0.2s linear;
    transform: translate3d(0, 0, 0);
  }

  &.move-enter, &.move-leave-active {
    transform: translate3d(0, 100%, 0);
  }

  .face-lists {
    border-top: 1px solid #e8e8e8;

    .face-list {
      float: left;
      width: 11.11%;
      padding: 12px 0 5px;
      text-align: center;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;

      .face {
        display: inline-block;
        width: 23px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/faceSelect.vue